// extracted by mini-css-extract-plugin
export default {"template":"DonationGoalLabelProperty_template__MtVMJ"};